// PlatformLayout — the sysadmin platform-portal frame (/platform/*). The symmetric
// counterpart to ProjectLayout / AdminLayout: a pathless layout route that caps its
// content to the shared `pageBox` and insets the `pageGutter`, so the platform pages
// (Projects · Users · SSO) live in the SAME boxed column as the project pages — one
// measure (1920px), one gutter, calm canvas wings on ultra-wide (DESIGN-TOKENS
// §Content measure). No rail: the platform nav is the top-bar tabs (PlatformNav),
// not a left sidebar — so it mirrors ProjectLayout, not AdminLayout.
//
// The top bar + the single <main> landmark stay in AuthedLayout; platform pages
// render BARE content inside this frame (never their own width cap / <main>).

import { Outlet } from 'react-router-dom';
import { PlatformPeekHost } from './PlatformPeekHost.js';
import { pageBox, pageGutter } from './pageBox.js';

export function PlatformLayout() {
  return (
    <div className={`${pageBox} flex-1 ${pageGutter} py-6`}>
      <Outlet />
      {/* Platform-tier entity-peek host (ADR-036 §2) — projects; any platform
          page opens one via ?peek=projects:<id>, never a page-local render. */}
      <PlatformPeekHost />
    </div>
  );
}
